export type ScriptChannel = 'dm' | 'email';

export type ScriptTemplate = {
  id: string;
  name: string;
  channel: ScriptChannel;
  /** Supports {{name}} for the talent nickname and {{product}} for the product name. */
  content: string;
  /** ISO 8601 timestamp. */
  updatedAt: string;
};

export const scriptChannelMeta: Record<ScriptChannel, { className: string }> = {
  dm: { className: 'bg-[#596ae8]/10 text-[#596ae8]' },
  email: { className: 'bg-sky-50 text-sky-600' }
};
